<template>
  <v-expansion-panels
    v-model="panel"
    class="mt-5"
    @change="onChange"
  >
    <part
      id="anchor-0"
      title="Kaupan tiedot"
      chapter="1"
    >
      <dias-real-estate-luovutusilmoitus :body="body" :config="config"/>
    </part>

    <part
      id="anchor-1"
      title="Myyjät"
      :invalid="!sellersFormValid || realtorPaymentInvalid"
      chapter="2"
    >
      <v-form
        ref="sellersForm"
        v-model="sellersFormValid"
      >
        <v-alert
          v-if="realtorPaymentInvalid"
          type="warning"
          text
          dense
          color="red"
        >
          Välityspalkkio ei ole yhteensä {{ realtorPaymentTotal / 100 | currency }}
        </v-alert>
        <dias-real-estate-sellers
          :body="body"
          :banks="banks"
        />
      </v-form>
    </part>

    <part
      id="anchor-2"
      title="Ostajat"
      chapter="3"
      :invalid="!buyersFormValid"
    >
      <v-form
        ref="buyersForm"
        v-model="buyersFormValid"
      >
        <dias-real-estate-buyers
          :body="body"
          :config="config"
          :banks="banks"
        />
      </v-form>
    </part>

    <part
      id="anchor-3"
      title="Luovutuksen ehdot"
      chapter="4"
    >
      <dias-real-estate-luovutuksen-ehdot
        v-if="panel === 3"
        :body="body"
        :config="config"
        :custom-conditions="customConditions"
      />
    </part>

    <part
      id="anchor-4"
      title="Panttikirjat"
      chapter="5"
      :invalid="!removePledges && !body.panttikirjojenKoodit?.length"
    >
      <dias-real-estate-pledges
        :body="body"
        :remove-pledges="removePledges"
      />

      <dias-real-estate-pledges-not-transferred
        v-if="body.eiSiirrettavatPanttikirjojenKoodit"
        class="mt-8"
        :body="body"
      />
    </part>

    <part
      id="anchor-5"
      title="Luovutettavat osuudet"
      chapter="6"
      :invalid="!fractionsFormValid"
    >
      <v-form
        ref="fractionsForm"
        v-model="fractionsFormValid"
      >
        <dias-real-estate-luovutettavat-osuudet
          :body="body"
        />
      </v-form>
    </part>

    <part
      id="anchor-6"
      title="Suostumuksen antajat"
      chapter="7"
      :invalid="!consentFormValid"
    >
      <v-form
        ref="consentForm"
        v-model="consentFormValid"
      >
        <dias-real-estate-suostujat
          :body="body"
          :config="config"
        />
      </v-form>
    </part>
  </v-expansion-panels>
</template>
<script>
import { sleep } from '@/utils';

export default {
  components: {
    'dias-real-estate-luovutusilmoitus': () => import('@/components/DIAS/DIASRealEstateLuovutusilmoitus'),
    'dias-real-estate-luovutuksen-ehdot': () => import('@/components/DIAS/DIASRealEstateLuovutuksenEhdot'),
    'dias-real-estate-buyers': () => import('@/components/DIAS/DIASRealEstateBuyers'),
    'dias-real-estate-sellers': () => import('@/components/DIAS/DIASRealEstateSellers'),
    'dias-real-estate-suostujat': () => import('@/components/DIAS/DIASRealEstateSuostujat'),
    'dias-real-estate-pledges': () => import('@/components/DIAS/DIASRealEstatePledges'),
    'dias-real-estate-pledges-not-transferred': () => import('@/components/DIAS/DIASRealEstatePledgesNotTransferred'),
    'dias-real-estate-luovutettavat-osuudet': () => import('@/components/DIAS/DIASRealEstateLuovutettavatOsuudet'),
    part: () => import('@/components/DIAS/DIASRealEstatePart'),
  },
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    customConditions: {
      type: Array,
      default: () => [],
    },
    realtorPaymentTotal: {
      type: Number,
      default: () => 0,
    },
    config: {
      type: Object,
      default: () => {},
    },
    banks: {
      type: Array,
      default: () => [],
    },
    removePledges: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    sellersFormValid: false,
    buyersFormValid: false,
    fractionsFormValid: false,
    consentFormValid: false,
    pledgesFormValid: false,
    panel: null,
  }),
  computed: {
    realtorPaymentInvalid() {
      let amount = 0;
      if (this.body.sellers) {
        this.body.sellers.forEach((seller) => {
          if (seller.realtorPayment) {
            amount += seller.realtorPayment.amountInCents;
          }
        });
      }

      return this.realtorPaymentTotal !== amount;
    },
  },
  methods: {
    async onChange(index) {
      if (index < 0) return;
      const target = `anchor-${index}`;
      const element = window.document.getElementById(target);

      if (!element) return;

      await sleep(400);
      this.scrollToTargetAdjusted(element);
    },

    scrollToTargetAdjusted(element) {
      const headerOffset = 75;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    },
  },
};
</script>
